import { AIStatusColors } from '../redux/features/ai/ai.constants';
import Colors from './color';

/**
 * Maps the live AI state to the AI status-bar background colour. Shared by the
 * legacy AIStatusBar (hitl_3_0 OFF) and the HITL 3.0 Customer Pulse status band
 * (hitl_3_0 ON) so the two stay in visual lockstep — a single source of truth
 * for the state→colour mapping, instead of each bar hardcoding its own values.
 */
const getStatusBarColor = (
  isAIEscalation: boolean,
  isAIEscalatedOnCarEnter: boolean,
  aiStatusColor: AIStatusColors
): string => {
  if (isAIEscalation) {
    // Red denotes escalation for every escalation type. A true takeover is
    // distinguished by the pulse animation (see showPulse), not by a separate
    // colour. Car-enter escalation keeps its orange identity.
    return isAIEscalatedOnCarEnter ? Colors.orange : Colors.red;
  }
  switch (aiStatusColor) {
    case AIStatusColors.green:
      return Colors.emerald;
    case AIStatusColors.yellow:
      return Colors.gold;
    case AIStatusColors.red:
      return Colors.bittersweet;
    default:
      return Colors.emerald;
  }
};

export default getStatusBarColor;
